export default __webpack_public_path__ + "static/media/Gothic Emotional Suspense Riser (vocal&choir) - AllenGrey.6407e72f.mp3";